import { MASK, TextFieldControl, TextFieldControlProps } from '@foxtaibox/foxtailbox-frontend-core';
import { useTranslation } from 'react-i18next';

interface PhoneNumberFieldControlProps extends Partial<TextFieldControlProps> {}

const PhoneNumberFieldControl = (props: PhoneNumberFieldControlProps) => {
  const { t } = useTranslation();

  return (
    <TextFieldControl
      name='phoneNumber'
      label={t('phoneNumber')}
      placeholder={t('phoneNumber')}
      type='tel'
      mask={MASK.PHONE_E164}
      {...props}
    />
  );
};

export default PhoneNumberFieldControl;
